type SortingProps = {
    onSortingType: (sort: string) => void
    sortType?: string;
}

export default function Sorting({ onSortingType, sortType }: SortingProps) {
    return <section className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8 pb-0">
        <div className="flex items-center justify-end">
            <select value={sortType || ""} onChange={(e) => {
                console.log("e.target.value ", e.target.value)
                onSortingType(e.target.value)
            }} className="rounded-md border border-border bg-card px-3 py-2 w-48 text-sm">
                <option value="" selected>Sortuj: Najnowsze</option>
                <option value="price_asc">Cena: od najniższej</option>
                <option value="price_desc">Cena: od najwyższej</option>
                <option value="name">Nazwa: A-Z</option>
            </select>
        </div>
    </section>
}